export const SET_EDIT_STAY_PROPERTY = 'SET_EDIT_STAY_PROPERTY'

export const updateProperty = hotelCode => ({
	type: SET_EDIT_STAY_PROPERTY,
	payload: hotelCode
})

export default function setEditStayProperty(hotelCode) {
	return dispatch => {
		dispatch(updateProperty(hotelCode))
	}
}



// WEBPACK FOOTER //
// ./src/actions/setEditStayProperty.js